(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Washi"] = factory();
	else
		root["Washi"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = isNode

function isNode (val) {
  return (!val || typeof val !== 'object')
    ? false
    : (typeof window === 'object' && typeof window.Node === 'object')
      ? (val instanceof window.Node)
      : (typeof val.nodeType === 'number') &&
        (typeof val.nodeName === 'string')
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/collection.js
// A layer on top of `Array.prototype` to allow for the generalization of these methods.
// Collection is mixed directly into `./util.js`, giving the chaining API for washi
// access to functional helpers.

// Save a shorthand reference to the Array prototype
var _ = Array.prototype;

// The whitelist contains all of the methods we want to pluck from Array
var whitelist = ['join', 'reverse', 'sort', 'push', 'pop', 'shift', 'unshift', 'splice', 'concat', 'slice', 'indexOf', 'lastIndexOf', 'forEach', 'map', 'reduce', 'reduceRight', 'filter', 'some', 'every'];

// Reduce the whitelist into an object of wrapped functions that apply
// upon a given list.
var collection = whitelist.reduce(function (memo, method) {
  memo[method] = function (list) {
    // Extract out the list argument
    var withoutList = _.slice.call(arguments, 1);

    // Then apply the Array method within the list context,
    // injecting all of the other arguments provided to this function
    return _[method].apply(list, withoutList);
  };

  return memo;
}, {});

// Next we add a few more helpers. Array.isArray and a method to convert list-like
// values into arrays (useful for working with arguments)
collection.isArray = Array.isArray;
collection.toArray = function (list) {
  return _.slice.call(list, 0);
};

/* harmony default export */ var src_collection = (collection);
// CONCATENATED MODULE: ./src/isObject.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Returns true only if given a true object. Not an array.


function isObject(obj) {
  // Determine that the object is not an array, then do a simple typeof check
  return src_collection.isArray(obj) !== true && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}
// CONCATENATED MODULE: ./src/extend.js
// Taken from Underscore. Given a list of arguments, extend a target
// object with those values.
//
// For example:
//
//      extend({ red: 'red' }, { blue: 'blue' });




function extend(target) {
  // Remove all keys that are not objects, for safety
  var valid = src_collection.filter(arguments, isObject);

  // For each valid argument
  valid.forEach(function (source) {
    // Take each member key of the source object
    Object.keys(source).forEach(function (key) {
      // And assign it to the target object
      target[key] = source[key];
    });
  });

  return target;
}
// EXTERNAL MODULE: ./node_modules/is-dom/index.js
var is_dom = __webpack_require__(0);
var is_dom_default = /*#__PURE__*/__webpack_require__.n(is_dom);

// CONCATENATED MODULE: ./src/tokenize.js
// Breaks apart words. Used in `./mapEvents`
function tokenize(string) {
  return string.split(/\s+/);
}
// CONCATENATED MODULE: ./src/isFunction.js
// Returns true if given a function.

function isFunction(obj) {
  return typeof obj === 'function';
}
// CONCATENATED MODULE: ./src/isBlank.js
// Given a value, returns true if null or undefiend

function isBlank(value) {
  return value === null || value === void 0;
}
// CONCATENATED MODULE: ./src/isUndefined.js
// Returns true of presented with an undefined value.
function isUndefined(obj) {
  return obj === void 0;
}
// CONCATENATED MODULE: ./src/result.js
// Check for ownership of a value, optionally calling it if it is a function. If
// the value is empty, return a default value
//
// Taken from Underscore
// https://github.com/jashkenas/underscore/blob/bc50d7a0e8d610b461f2d520c2f9f13e5c52f179/underscore.js#L1285-L1293
//
// For example:
//
//     result(obj, 'member', fallback)




function result_result(target, property, fallback) {
  var value = isBlank(target) ? void 0 : target[property];

  if (isUndefined(value)) {
    value = fallback;
  }

  return isFunction(value) ? value.call(target) : value;
}
// CONCATENATED MODULE: ./src/classList.js
// A collection of methods for manipulating classes.




var classList = {
  // Given an element and a string of classes, add those classes if
  // the element is a DOM node
  addClass: function addClass(el, classes) {
    if (is_dom_default()(el)) {
      tokenize(classes).map(function (token) {
        el.classList.add(token);
      });
    }
  },

  // Given an element and a string of classes, remove those classes if
  // the element is a DOM node
  removeClass: function removeClass(el, classes) {
    if (is_dom_default()(el)) {
      tokenize(classes).map(function (token) {
        el.classList.remove(token);
      });
    }
  },

  // Given an element and a string of classes, add or remove those classes
  // based upon a boolean
  toggleClass: function toggleClass(el, classes, keep) {
    if (is_dom_default()(el) && arguments.length === 2) {
      tokenize(classes).map(function (token) {
        el.classList.toggle(token);
      });
    } else {
      if (keep) {
        classList.addClass(el, classes);
      } else {
        classList.removeClass(el, classes);
      }
    }
  }
};

/* harmony default export */ var src_classList = (classList);
// CONCATENATED MODULE: ./src/chain.js
/**
 * chain()
 * Creates a pipeline for executing multiple operatins on a value, this
 * can be a single object or a list of values. Use `valueOf()` to end
 * the chain, returning the underlying value.
 *
 * @example
 *   let chain = Washi.$.chain([1,2,3]).map(i => i + 1)
 *   let result = chain.valueOf()
 *
 *   console.log(result) // [2,3,4]
 *
 * @param {Object | Array} target Starting value of the chain
 */

//
// Example: `chain(Array.prototype)([1, 2, 3, 4 ]).join(' ').valueOf();`





function buildChain(target) {
  // Return a scoped function so each fork of a chain has its own working value
  // This way, additional chains do not mutate the state of other chains.
  return function (value, scope) {
    var chain = {};

    // Returns a function that will execute a given method
    // upon the `value`, reassigning `value if the result
    // of the function is defined.
    var getChainable = function getChainable(method) {
      return function () {
        var args = src_collection.toArray(arguments);

        args.unshift(value);

        var result = method.apply(scope, args);

        if (!isUndefined(result)) {
          value = result;
        }

        return chain;
      };
    };

    // Extend the chain object with the members of the target. This process
    // is similar to how `./collection.js` is built however the returned
    // result of each invocation is the chain itself.
    for (var d in target) {
      chain[d] = getChainable(target[d]);
    }

    // `chain.valueOf` allows the retrieval of the source value
    chain.valueOf = function () {
      return value;
    };

    // Allows the retrieval of a specific key in the source value
    // with an optional fallback
    chain.get = function (key, fallback) {
      return result_result(value, key, fallback);
    };

    return chain;
  };
}
// CONCATENATED MODULE: ./src/has.js
// Taken from Underscore, this is a predicate that identifies ownership of an attribute.
//
// For example:
//
//      hasOwnProperty({}, 'foo') // => false
//      hasOwnProperty(null, 'foo') // => false
//      hasOwnProperty({ foo: 'bar' }, 'foo') // => true



var has_hasOwnProperty = Object.prototype.hasOwnProperty;

function has(obj, property) {
  // If the object is blank, just return false. Otherwise check for membership.
  // This prevents errors where `null` or `undefined` are accidentally
  // provided to hasOwnProperty
  return isBlank(obj) ? false : has_hasOwnProperty.call(obj, property);
}
// CONCATENATED MODULE: ./src/isString.js
// Returns true of presented a string
function isString(obj) {
  return typeof obj === 'string';
}
// CONCATENATED MODULE: ./src/query.js
// An abstraction around document.querySelector.
//
// - Given an element, it returns it.
// - Given a string, it performs a selection
// - Otherwise returns null
//
// For example:
//
//     query('.selector')
//     query('.selector', document.body);




function query_query(selector, root) {
  if (is_dom_default()(selector)) {
    // Don't do any needless work if the first argument is already an element
    return selector;
  }

  if (isString(selector)) {
    // For safety, always check if the root is an actual DOM element
    return (is_dom_default()(root) ? root : document).querySelector(elector);
  }

  return null;
}
// CONCATENATED MODULE: ./src/queryAll.js
// An abstraction around document.querySelectorAll.
//
// - Given an array of elements, it will return the reduction of running queryAll on all items.
// - Given an element, it will return that element embedded in an array
// - Given a string, it will return the result of executing element.querySelectorAll






function queryAll(el, selector) {
  var hasSelector = isUndefined(selector) === false;

  if (src_collection.isArray(el)) {
    // If the element is an array, and a selector is given,
    // return the reduction of selecting upon each item
    if (hasSelector) {
      return el.reduce(function (a, b) {
        return a.concat(findAll(b, selector));
      }, []);
    } else {
      // Otherwise just return the element list
      return el;
    }
  }

  // If no selector is given, but el is a DOM element then
  // just return the element in an array
  if (!hasSelector && is_dom_default()(el)) {
    return [el];
  }

  // If `el` is actually a selector, findAll from document
  if (!hasSelector && isString(el)) {
    selector = el;
    el = document;
  }

  // Finally, grab selections
  var query = el.querySelectorAll(selector);

  // Find anything? otherwise return an empty list
  return query ? src_collection.slice(query, 0) : [];
}

/* harmony default export */ var src_queryAll = (queryAll);
// CONCATENATED MODULE: ./src/invoke.js
// Execute a command on each member of a list;

// For example:
//
//     invoke([1, 2, 3 ], 'toString')


function invoke(list, method) {
  var args = src_collection.slice(arguments, 2);

  return list.map(function (item) {
    return item[method].apply(item, args);
  });
}
// CONCATENATED MODULE: ./src/isRegExp.js
var isRegExp_toString = {}.toString;

function isRegExp(value) {
  return isRegExp_toString.call(value) === '[object RegExp]';
}
// CONCATENATED MODULE: ./src/matches.js
// Given an element and selector, returns true of the selector matches.
// This uses the native Element.matches API when possible.
//
// For example:
//
//     matches(document.body, 'body') // => true



var proto = Element.prototype;
var vendor = proto.matches || proto.matchesSelector || proto.webkitMatchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector;

function isNotMatchable(value) {
  return is_dom_default()(value) === false || value === document;
}

function match(el, selector) {
  // Always return false if the element provided is not a DOM Element
  // or is the document. This catches an illegal invocation error.
  if (isNotMatchable(el)) {
    return false;
  }

  // Element.matches is still a newer feature, so it must be identified
  // that it is supported
  if (vendor) {
    return vendor.call(el, selector);
  }

  // Otherwise we traverse the tree
  var nodes = el.parentNode.querySelectorAll(selector);

  for (var i = 0; i < nodes.length; ++i) {
    if (nodes[i] == el) {
      return true;
    }
  }

  return false;
}
// CONCATENATED MODULE: ./src/event.js
function on(element, event, callback, capture) {
  !element.addEventListener && (event = 'on' + event);

  if (element.addEventListener) {
    element.addEventListener(event, callback, capture);
  } else {
    element.attachEvent(event, callback, capture);
  }

  return callback;
}

function off(element, event, callback, capture) {
  !element.removeEventListener && (event = 'on' + event);

  if (element.removeEventListener) {
    element.removeEventListener(event, callback, capture);
  } else {
    element.detachEvent(event, callback, capture);
  }

  return callback;
}

/* harmony default export */ var src_event = (on);
// CONCATENATED MODULE: ./src/delegate.js
// Handles event binding, be it through delegation or otherwise.
//
// Example: delegate(window, 'resize', callback);
// Example: delegate(document.body, 'click', 'main', callback);






function delegate(el, type, selector, fn, capture) {
  // Add an event binding who's callback first checks to identify
  // if the target element matches the given selector
  function bubble(target, e) {
    var hasParent = is_dom_default()(target.parentNode);
    var canBubble = target.parentNode !== el;

    if (match(target, selector)) {
      fn.call(target, e);
    } else if (hasParent && canBubble) {
      bubble(target.parentNode, e);
    }
  }

  return on(el, type, function (e) {
    bubble(e.target || e.srcElement, e);
  }, capture);
}

function guardDelegate(el, type, selector, fn, capture) {
  if (isString(selector) && selector.length > 0) {
    // If given a non-empty string selector, this function will perform delegation.
    return delegate(el, type, selector, fn, capture);
  } else {
    // Otherwise it performs standard event binding
    return on(el, type, fn, capture);
  }
}
// CONCATENATED MODULE: ./src/template.js
// An intentionally simple templating language. This function is used to swap out event names
// when binding with `mapEvents`. Replaces instances of {value} given an object of properties.
// If these values are absent, nothing is replaced
//
// For example:
//
//     template('{foo}', { foo: 'bar' }) //=> 'bar'
//     template('{foo}') //=> '{foo}'




// The template function will use this pattern to match values
var pattern = /\{([\s\S]+?)\}/g;

function template(string, pool) {
  // Don't match values if there's nothing to replace
  if (isBlank(pool)) {
    return string;
  }

  // Otherwise replace all instances of `{key}` with the value
  // of the passed `pool` argument. If a key doesn't exist, then
  // just return the whole match.
  return string.replace(pattern, function (whole, capture) {
    return result_result(pool, capture.trim(), whole);
  });
}

// Expose the templating pattern so that it can be overriden
Object.defineProperty(template, 'pattern', {
  get: function get() {
    return pattern;
  },
  set: function set(newPattern) {
    if (isRegExp(newPattern)) {
      pattern = newPattern;
    } else {
      throw new TypeError('template.setPattern expects a regular expression');
    }
  }
});

/* harmony default export */ var src_template = (template);
// CONCATENATED MODULE: ./src/mapEvents.js
// Given an element, an object of events, a pool of selectors, and a scope,
// this function binds those events within the provided scope.
//
// For example:
//
//     mapEvents(window, { resize: method }, {}, obj)
//     mapEvents(document.boyd, { 'click {items}': method }, { items: '.class' }, obj);






function bindEvent(el, name, method, selectors, scope) {
  var items = name.split(',');
  var toCall = (isFunction(method) ? method : scope[method]).bind(scope);

  while (items.length) {
    var tokens = tokenize(src_template(items.pop(), selectors));

    guardDelegate(el, tokens[0], tokens[1], toCall);
  }
}

function mapEvents(el, events, selectors, scope) {
  for (var name in events) {
    bindEvent(el, name, events[name], selectors, scope);
  }
}
// CONCATENATED MODULE: ./src/tap.js
// Useful when chaining, simply calls a function within a given scope on a set of items.
function tap(target, fn, scope) {
  fn.call(scope, target);
}
// CONCATENATED MODULE: ./src/append.js
// A DOM operation helper. Append an Element to a parent
function append(parent) {
  // Always select the first item of a list, similarly to jQuery
  if (Array.isArray(parent)) {
    parent = parent[0];
  }

  for (var _len = arguments.length, children = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    children[_key - 1] = arguments[_key];
  }

  children.forEach(parent.appendChild, parent);

  return parent;
}
// CONCATENATED MODULE: ./src/remove.js
// A DOM operation helper to remove children
function remove(element) {
  if (Array.isArray(element)) {
    element.forEach(remove);
    return element;
  }

  element.parentNode.removeChild(element);

  return element;
}
// CONCATENATED MODULE: ./src/util.js

























// Util is a function that returns the result of calling `chain` upon a given value and scope.
var Util = function Util(value, scope) {
  if (Util.isString(value)) {
    value = Util.queryAll(value);
  }

  return Util.chain(value, scope);
};

// Additionally, it is extended with every method used by Washi interally. Naturally,
// you can extend this as you see fit. Any member value of `Util` will be sent into
// the chaining API.
extend(Util, src_collection, src_classList, {
  chain: buildChain(Util),
  chainWith: buildChain,
  extend: extend,
  has: has,
  query: query_query,
  queryAll: src_queryAll,
  invoke: invoke,
  isBlank: isBlank,
  isDOM: is_dom_default.a,
  isFunction: isFunction,
  isObject: isObject,
  isRegExp: isRegExp,
  isString: isString,
  isUndefined: isUndefined,
  mapEvents: mapEvents,
  matches: match,
  on: on,
  off: off,
  result: result_result,
  tap: tap,
  template: src_template,
  tokenize: tokenize,

  // DOM operations
  append: append,
  remove: remove
});

/* harmony default export */ var util = (Util);
// CONCATENATED MODULE: ./src/mapSelections.js
// Given an object who's keys are names and values are selectors, produce a new object
// with getters that select upon a given element.
//
// For example:
//
//     mapSelection(document.body, { paragraphs: 'p', links: 'a' });



function mapSelections(el, ui) {
  var assignments = {};

  // For each attribute, perform a selection
  // within the context of this View's element
  for (var component in ui) {
    assignments[component] = src_queryAll(el, ui[component]);
    assignments['$' + component] = util(assignments[component]);
  }

  return assignments;
}
// CONCATENATED MODULE: ./washi.js
// Washi
//
// by Viget
// https://github.com/vigetlabs/washi
// https://viget.com
//
// Washi is a DOM utility library with inspirations from Backbone, Underscore,
// and React. You build washi components by constructing objects with a given
// pattern, then invoking Washi upon that object.





function Washi() {
  var options = util.extend.apply(null, [{}].concat(util.toArray(arguments)));
  var selection = util.queryAll(result_result(options, 'el', document.body));

  return Washi.$(selection).map(function (el) {
    return factory(options, { el: el });
  });
}

// Expose the utility helpers. Assigned to $ for familiarity with Backbone Views.
Washi.$ = util;

function factory() {
  // Construct a new object, building from a given prototype and
  // folding in all "mixins"
  var options = util.extend.apply(null, util.toArray(arguments));
  var assembled = util.extend(Object.create(Washi.prototype), options);

  // Verify our element exists
  assembled.el = util.query(result_result(assembled, 'el', document.body));
  assembled.$el = util(assembled.el);

  // Bind events. Taken the target `el` and assign `events` to it, using `ui` when running
  // the `template` function upon the event declarations.
  util.mapEvents(assembled.el, result_result(assembled, 'events'), result_result(assembled, 'ui'), assembled);

  // Next, reassign the UI object using `mapSelections` to construct getters that return
  // query selections.
  assembled.ui = mapSelections(assembled.el, result_result(assembled, 'ui'));

  // Setup a selector helper method, a short hand similar to Backbone's `View.$`
  assembled.$ = util(assembled.el);

  // Call the initialize method on the object. This is useful as a pseudo
  // replacement for the constructor function
  if (typeof assembled.initialize === 'function') {
    assembled.initialize(options);
  }

  return assembled;
}

/* harmony default export */ var washi = __webpack_exports__["default"] = (Washi);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// washi.js